import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LessorSetupRequest } from '@/models/payment';
import { usePaymentsMutations } from '@/services/paymentsMutations';
import { useHandleResponse } from '@/lib/hooks/useHandleResponse';
import { InputText } from '@/components/shared/InputText';
import { Box, Grid2 } from '@mui/material';
import {
    PrimaryButtonStyle,
    SecondaryButtonStyle
} from '@/pages/company/common/IntegrationDialog';

interface LessorConnectProps {
    onClose?: () => void;
    onSaveSuccess: any;
    LessorButtonTitle?: any;
}

export const LessorConnect = (props: LessorConnectProps) => {
    const { t } = useTranslation();
    const [lessorData, setLessorData] = useState<LessorSetupRequest>({
        InstaPaidSalaryTypeId: ''
    });
    const { lessorSetup } = usePaymentsMutations();

    const onClick = () => {
        lessorSetup.mutate(lessorData);
    };

    useHandleResponse({
        isSuccess: lessorSetup.isSuccess,
        error: lessorSetup.error,
        isPending: lessorSetup.isPending,
        successAlertMessage: t('connected'),
        isSuccessCallBack: () => {
            props.onSaveSuccess();
        }
    });

    return (
        <>
            <Box width={'100%'} margin={'20px 0 10px'}>
                <InputText
                    value={lessorData.InstaPaidSalaryTypeId}
                    label={t('instapaid_salary_type_id')}
                    placeholder={t('enter_instapaid_salary_type_id')}
                    onChange={(e) => {
                        setLessorData({
                            ...lessorData,
                            InstaPaidSalaryTypeId: e.target.value
                        });
                    }}
                    spacing="10px 0"
                />
            </Box>

            <Grid2
                container
                spacing={2}
                justifyContent={'space-around'}
                sx={{ m: '20px 0' }}
            >
                <Grid2>
                    <SecondaryButtonStyle
                        onClick={props.onClose}
                        sx={{ width: '170px' }}
                    >
                        {t('back')}
                    </SecondaryButtonStyle>
                </Grid2>

                <Grid2>
                    <PrimaryButtonStyle
                        onClick={onClick}
                        sx={{ width: '170px' }}
                        loading={lessorSetup.isPending}
                        disabled={!lessorData.InstaPaidSalaryTypeId}
                    >
                        {props?.LessorButtonTitle
                            ? props?.LessorButtonTitle
                            : t('connect')}
                    </PrimaryButtonStyle>
                </Grid2>
            </Grid2>
        </>
    );
};
